import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { colors } from '@/constants/colors';

const BillingFailure = () => {
   const navigate = useNavigate();

   return (
      <Container>
         <Card>
            <ErrorIcon />
            <Title>Payment Failed</Title>
            <Message>
               We're sorry, but your payment could not be processed at this
               time. This could be due to insufficient funds or a temporary
               issue with the payment system.
            </Message>
            <Button onClick={() => navigate('/billing')}>
               Return to Billing
            </Button>
         </Card>
      </Container>
   );
};

export default BillingFailure;

// Animations
const fadeIn = keyframes`
   from { opacity: 0; }
   to { opacity: 1; }
`;

const errorShake = keyframes`
   0%, 100% { transform: translateX(0); }
   25% { transform: translateX(-5px); }
   75% { transform: translateX(5px); }
`;

// Styled Components
const Container = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   min-height: 100vh;
   background-color: ${colors.GRAY14};
   padding: 1rem;
`;

const Card = styled.div`
   background: var(--app-surface);
   padding: 2rem;
   border-radius: 1rem;
   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
   text-align: center;
   max-width: 400px;
   width: 100%;
   animation: ${fadeIn} 0.5s ease-in;
`;

const ErrorIcon = styled.div`
   width: 50px;
   height: 50px;
   border-radius: 50%;
   background: ${colors.DANGER};
   margin: 0 auto 1.5rem;
   position: relative;
   animation: ${errorShake} 0.5s ease-in-out;

   &:before,
   &:after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 20px;
      height: 3px;
      background: var(--app-surface);
   }

   &:before {
      transform: translate(-50%, -50%) rotate(45deg);
   }

   &:after {
      transform: translate(-50%, -50%) rotate(-45deg);
   }
`;

const Title = styled.h1`
   color: ${colors.GRAY1};
   font-size: 1.5rem;
   margin-bottom: 1rem;
   font-weight: 600;
`;

const Message = styled.p`
   color: ${colors.GRAY4};
   font-size: 1rem;
   line-height: 1.5;
   margin-bottom: 1.5rem;
`;

const Button = styled.button`
   /* background: ${colors.PRIMARY}; */
   outline: none;
   background: none;
   color: ${colors.PRIMARY};
   border: none;
   padding: 0.75rem 1.5rem;
   border-radius: 0.5rem;
   font-weight: 500;
   text-decoration: underline;
   cursor: pointer;
   /* transition: background-color 0.2s; */

   /* &:hover {
      background: ${colors.PRIMARY90};
   } */
`;
